/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";

import Image from "./Image";
// import CroppingModal from "./CroppingModal";

class ImagesList extends Component {
  state = {
    croppingModalVisibility: false,
    selectedImageForCropping: {}
  };

  render() {
    const { images, onChecked } = this.props;
    if (images) {
      return images.map(image => (
        <div key={image.uid}>
          <Image
            image={image}
            onChecked={onChecked}
            onMenuClick={this.handleMenuClick}
          />
        </div>
      ));
    } else {
      return null;
    }
  }
}

export default ImagesList;
